import { ArticleRounded } from "@mui/icons-material";
import { Box, Card, Tab, Tabs, Typography } from "@mui/material";
import React, { PropsWithChildren, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { cms_amiforyou, cms_app_polling, cms_banners, cms_media, cms_news } from "../../routes/routes_path";
import { black, greyEnabled, purple, purpleLight } from "../../theme/colors";

const TAB_SUBTITLES = [
  "Manage news articles shown across the app.",
  "Manage promotional banners shown across the app.",
  "Manage images and videos used across news and banners.",
  "Manage AMI For You items shown in the mobile app.",
  "Manage polls shown in the mobile app and view their results.",
];

const HEADER_ICON_BADGE = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 44,
  height: 44,
  borderRadius: 2,
  bgcolor: purpleLight,
  flexShrink: 0,
} as const;

export default function CmsLayout({ children }: PropsWithChildren<{}>) {
  const [currentTab, setCurrentTab] = React.useState(0);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleChange = (event: React.SyntheticEvent, currentTabVal: number) => {
    setCurrentTab(currentTabVal);
    routeBasedOnTabChange(currentTabVal);
  };

  function routeBasedOnTabChange(currentTabVal: number) {
    if (currentTabVal === 0) {
      navigate(cms_news);
    } else if (currentTabVal === 1) {
      navigate(cms_banners);
    } else if (currentTabVal === 2) {
      navigate(cms_media);
    } else if (currentTabVal === 3) {
      navigate(cms_amiforyou);
    } else {
      navigate(cms_app_polling);
    }
  }

  function tabChangeBasedOnRoute() {
    if (pathname.startsWith(cms_banners)) {
      setCurrentTab(1);
    } else if (pathname.startsWith(cms_media)) {
      setCurrentTab(2);
    } else if (pathname.startsWith(cms_amiforyou)) {
      setCurrentTab(3);
    } else if (pathname.startsWith(cms_app_polling)) {
      setCurrentTab(4);
    } else {
      setCurrentTab(0);
    }
  }

  useEffect(() => {
    tabChangeBasedOnRoute();
  }, [pathname]);

  return (
    <Box>
      <Box display="flex" alignItems="center" gap={1.5}>
        <Box sx={HEADER_ICON_BADGE}>
          <ArticleRounded sx={{ color: purple, fontSize: 24 }} />
        </Box>
        <Box>
          <Typography variant="h5" fontWeight={700} color={black}>
            CMS
          </Typography>
          <Typography variant="body2" color={greyEnabled} mt={0.5}>
            {TAB_SUBTITLES[currentTab]}
          </Typography>
        </Box>
      </Box>

      <Card
        elevation={0}
        sx={{
          display: "flex",
          mt: 2,
          width: "100%",
          minHeight: 600,
          mb: 2,
          minWidth: 1200,
          borderRadius: 3,
          border: "1px solid #ECECEC",
        }}
      >
        <Box display="flex" flexDirection={"column"} sx={{ width: "100%" }}>
          <Box
            sx={{
              borderBottom: "1px solid #ECECEC",
              px: 3,
              pt: 1,
            }}
          >
            <Tabs
              value={currentTab}
              aria-label="cms tabs"
              onChange={handleChange}
              TabIndicatorProps={{
                style: { backgroundColor: purple, height: 3, borderRadius: 3 },
              }}
            >
              <Tab
                label="News"
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  color: greyEnabled,
                  "&.Mui-selected": { color: purple },
                }}
              />
              <Tab
                label="Banners"
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  color: greyEnabled,
                  "&.Mui-selected": { color: purple },
                }}
              />
              <Tab
                label="Media"
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  color: greyEnabled,
                  "&.Mui-selected": { color: purple },
                }}
              />
              <Tab
                label="AMI For You"
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  color: greyEnabled,
                  "&.Mui-selected": { color: purple },
                }}
              />
              <Tab
                label="App Polling"
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  color: greyEnabled,
                  "&.Mui-selected": { color: purple },
                }}
              />
            </Tabs>
          </Box>
          {children}
        </Box>
      </Card>
    </Box>
  );
}
